import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Tooltip from "components/Tooltip";

interface CertificationSystemCardProps {
  title: string;
  icon: string;
  /** Settings key, used as the image alt. */
  alt: string;
  /** Tier 2: only enabled (active in Building Settings) cards are clickable. */
  enabled: boolean;
  onSelect: () => void;
}

const CertificationSystemCard = ({
  title,
  icon,
  alt,
  enabled,
  onSelect,
}: CertificationSystemCardProps) => {
  const { t } = useTranslation();

  const card = (
    <div
      onClick={enabled ? onSelect : undefined}
      className={clsx(
        "flex flex-col border rounded-md items-center justify-center",
        "p-[20px] shadow-sm w-full h-full",
        enabled
          ? "border-gray-200 cursor-pointer hover:bg-indigo-50 hover:ring-1 hover:ring-indigo-600 hover:border-indigo-600"
          : "border-gray-200 bg-gray-50 opacity-60 cursor-not-allowed"
      )}
    >
      <span className="text-base font-semibold text-gray-900 mb-4 text-left w-full">
        {title}
      </span>
      <img src={icon} alt={alt} />
    </div>
  );

  if (enabled) return card;

  return (
    <Tooltip
      content={t("certExport.enableInSettingsTooltip")}
      noFlex
      className="h-full"
    >
      {card}
    </Tooltip>
  );
};

export default CertificationSystemCard;
